export enum CompleteStatusEnum {
  All = 1,
  NotComplete = 2,
  Complete = 3,
}

export enum KeywordTypeEnum {
  Content = 1,
}

interface Keyword {
  value: string;
  type: KeywordTypeEnum;
}

export enum DateTypeEnum {
  RegTime = 1,
  ActionTime = 2,
}

export enum InquiryCategoryEnum {
  AccessParking = 1, // アクセス・駐車場
  AccommodationsGuestRooms = 2, // 宿泊・客室
  DiningRestaurants = 3, // 食事・レストラン
  FacilitiesEquipment = 4, // 館内施設・設備
  Bathing = 5, // 入浴・風呂
  BringingChildren = 6, // 子供連れでの利用
  Activities = 7, // アクティビティ
  Pets = 8, // ペット
  NeighborhoodInformation = 9, // 周辺情報
  Other = 10, // その他
  ReservationChange = 11, // 予約の変更
  Unknown = 0,
}

type InquiryCategories = {
  [key in InquiryCategoryEnum]: boolean;
};

export enum SortOrderEnum {
  LastDesc = 'lastDesc',
  LastAsc = 'lastAsc',
  InitialDesc = 'initialDesc',
  InitialAsc = 'initialAsc',
}

export interface IFilters {
  keyword: Keyword;
  date: {
    to: string;
    from: string;
    type: DateTypeEnum;
    isCleared: boolean;
    clearedType: string;
  };
  categoryId: number | null;
  completeStatus: CompleteStatusEnum;
  replyStatus: {
    replied: boolean;
    nonReplied: boolean;
  };
  sortOrder: SortOrderEnum;
}

export type DateIsClearedTypeKey = '2_YEARS' | '1_YEAR' | '1_MONTH' | '1_WEEK';

export type DateIsClearedTypeObject = {
  label: string;
  interval: { type: 'years' | 'months' | 'weeks' | 'days'; number: number };
};
